const rootAPI = `https://m2intel.com:5050`;
const rootAPISec = `https://m2intel.com:6001`;
// const rootAPI = `https://localhost:5001`;
// const rootAPI = `https://172.18.78.221:5001`;

export default {
    getUrl(name:string, id?:string):string {
        switch (name) {
            case 'reports':
                return `${rootAPI}/api/Summary/list`;
            case 'report':
                return `${rootAPI}/api/Summary`;
            case 'reportGUID':
                return `${rootAPI}/reports/SummaryReport`;
            case 'reportPDF':
                return `${rootAPI}/reports/SummaryReport/Download`;
            case 'form':
                return `${rootAPI}/api/Question/branchId`;
            case 'branches':
                return `${rootAPI}/api/Branches`;
            case 'login':
                return `${rootAPI}/api/Userlogin/Login`;
            case 'userInfo':
                return `${rootAPISec}/connect/userinfo`;
            case 'logout': // TODO LOGOUT
                return `${rootAPI}/api/Auth`;
            default:
                return ''
        }
    }
}
